import { render, staticRenderFns } from "./New_step.vue?vue&type=template&id=04f64c70&scoped=true&"
import script from "./New_step.vue?vue&type=script&lang=js&"
export * from "./New_step.vue?vue&type=script&lang=js&"
import style0 from "./New_step.vue?vue&type=style&index=0&id=04f64c70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f64c70",
  null
  
)

export default component.exports